import { Lightning } from '@lightningjs/sdk';
import { ProfileAvatar } from './ProfileAvatar';

export class ProfileAvatarSelectionBox extends Lightning.Component {
  static _template() {
    return {
      w: w => w,
      h: h => h,
      clipping: true,
      AvatarContainer: {
        flex: {
          direction: 'row',
        },
      },
    };
  }

  _init() {
    this._index = 0;
  }

  set data(d) {
    this._avatars = d.avatars;
    this._data = d.data;
    this._avatars.forEach(item => {
      this.tag('AvatarContainer').childList.add({
        type: ProfileAvatar,
        image: item.image,
      });
    });
    this.stage.update();
    if (this._data) {
      this._index = this._avatars.findIndex(item => item.id === this._data.profile.avatar);
    }
    this.tag('AvatarContainer').children[this._index].showBorder = true;
    this.centerCard();
  }

  get selectedAvatar() {
    return this._avatars[this._index];
  }

  _getFocused() {
    return this.tag('AvatarContainer').children[this._index];
  }

  _unfocus() {
    this.tag('AvatarContainer').children[this._index].showBorder = true;
  }

  _handleLeft() {
    if (this._index > 0) {
      this._index = this._index - 1;
      this.centerCard();
      return true;
    } else {
      this._index = this.tag('AvatarContainer').children.length - 1;
      this.centerCard();
    }
    return false;
  }

  _handleRight() {
    if (this._index < this.tag('AvatarContainer').children.length - 1) {
      this._index = this._index + 1;
      this.centerCard();
      return true;
    } else {
      this._index = 0;
      this.centerCard();
    }
    return false;
  }

  centerCard() {
    if (this._index === -1) {
      return;
    }
    const avatarContainer = this.tag('AvatarContainer');
    let avatar = this.tag('AvatarContainer').children[this._index];

    const cardCenter = avatar.finalX + avatar.finalW * 0.5;
    const sliderCenter = this.finalW * 0.5;
    const result = Math.min(0, Math.max(this.finalW - avatarContainer.finalW, sliderCenter - cardCenter));

    this.tag('AvatarContainer').setSmooth('x', result);
  }
}
